/**
 * @generated SignedSource<<f746adf076ca4df9723d98c5b57da77d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductRole = "instructor" | "manager" | "member" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProductMemberCardFragment$data = {
  readonly id: string;
  readonly member: {
    readonly avatar: string;
    readonly firstName: string | null;
    readonly id: string;
    readonly lastName: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"UserCardFragment">;
  };
  readonly role: ProductRole;
  readonly " $fragmentSpreads": FragmentRefs<"MakeProductTeacherButtonFragment" | "UnenrollProductMemberButtonFragment" | "useMemberGroupTagsList_ProductMembershipFragment">;
  readonly " $fragmentType": "ProductMemberCardFragment";
};
export type ProductMemberCardFragment$key = {
  readonly " $data"?: ProductMemberCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductMemberCardFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "canMakeTeacher"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "canUnenroll"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductMemberCardFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "condition": "canMakeTeacher",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MakeProductTeacherButtonFragment"
        }
      ]
    },
    {
      "condition": "canUnenroll",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UnenrollProductMemberButtonFragment"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMemberGroupTagsList_ProductMembershipFragment"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "member",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "avatar",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserCardFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductMembership",
  "abstractKey": null
};
})();

(node as any).hash = "84c822762ab06aac755dfcfe910af0bf";

export default node;
